<b3-drawer
  [open]="open"
  size="md"
  overlay
  (b3-close)="close()"
  (b3-back)="close()">
  <b3-drawer-header
    heading="Detalhes da Operação"
    show-back
    back-aria-label="Fechar detalhes da operação">
  </b3-drawer-header>

  <b3-drawer-body>
    <div class="operation-details-drawer">
      <div class="operation-details-drawer__badges">
        <b3-tag
          size="sm"
          variant="filled"
          icon="logout"
          tone="warning"
          label="Retirada">
        </b3-tag>
      </div>

      <div class="operation-details-drawer__field operation-details-drawer__field--full">
        <span class="operation-details-drawer__label">Motivo da retirada</span>
        <span class="operation-details-drawer__value">{{ withdrawalReason }}</span>
      </div>

      <div class="operation-details-drawer__actions">
        <b3-button
          class="operation-details-drawer__confirm-btn"
          type="button"
          variant="filled"
          tone="default"
          (b3-click)="close()">
          <b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
          Entendi
        </b3-button>
      </div>
    </div>
  </b3-drawer-body>
</b3-drawer>
